import styled from "styled-components";
import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import Fade from 'react-reveal/Fade';
//Icons
import {HiUserGroup} from "react-icons/hi";
import {AiFillPlayCircle} from "react-icons/ai";
import {BsFillPaletteFill, BsFillFileEarmarkCodeFill, BsServer} from "react-icons/bs";
import {MdDesignServices} from "react-icons/md";
import {RiCustomerService2Fill} from "react-icons/ri";
import {FaComments} from "react-icons/fa";
import {GiClick} from "react-icons/gi";
import {IoIosBeer} from "react-icons/io";
function TimeYear(props){
    //Variable and condition for change up side and down side.
    let changeLine;
    if(props.up === "true"){
        changeLine = false;
    }
    else{
        changeLine = true;
    }
    /*
    Podmínka ohledně nahoru a dolů s linií!
     */
    return(
        <TimeYearBlock>
            <Year className="f-inter">
                {props.year}
            </Year>
            <Line>
                <Circle>
                    <VerticalLine className={changeLine? "downLine" : "upLine"}>
                        <div className={changeLine? "downInfo" : "UpInfo"}>
                            {props.info}
                        </div>
                    </VerticalLine>
                </Circle>
            </Line>
        </TimeYearBlock>
    );
}
const TimeYearBlock = styled.div`
  display:flex;
  align-items: center;
  position:relative;
  flex: none;
`;
const Line = styled.div`
  width:400px;
  height:6px;
  background-color:#F5F5F5;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const Year = styled.div`
  z-index: 2;
  display:flex;
  justify-content: center;
  align-items: center;
  background-color:#F5F5F5;
  color:var(--main-color);
  font-size:22px;
  font-weight: bold;
  
  width: 100px;
  height: 70px;
  border-radius:20px 20px 0 20px;
`;
const Circle = styled.div`
  z-index: 11;
  background-color:#741619;
  width:30px;
  height: 30px;
  border-radius: 50%;
  
  display:flex;
  justify-content: center;
  .upLine{
    bottom: 130px;
  }
`;
const VerticalLine = styled.div`
  position:relative;
  
  display:flex;
  justify-content: center;
  
  margin-top:30px;
  z-index: 1;
  width:1px;
  border-right:4px dotted #741619;
  height: 100px;
  
  font-size:18px;
  
  
  .downInfo{
    width: 200px;
    top: 115px;
    position: absolute;
    text-align: center;
  }
  .UpInfo{
    width: 200px;
    bottom: 115px;
    position: absolute;
    text-align: center;
  }
`;
function AboutUs(){
    const ref = useRef();
    const { events } = useDraggable(ref);

    const ref1 = useRef();
    const { events: events1 } = useDraggable(ref1, {
        applyRubberBandEffect: true,
    });

    return(
        <Block className="blocks-padding">
            <div className="layout">
                <div className="title-padding-1-bottom">
                    <Fade top>
                        <TitleBlock className="slide-in">
                            O nás
                        </TitleBlock>
                        <Text>
                            Každý z nás píše příběh v životě i my píšeme
                        </Text>
                    </Fade>
                </div>
            </div>
            <TimeLine {...events} ref={ref}>
                <HelpTimeLine>
                    <div className="title f-inter">
                        Chcete-li prozkoumat náš příběh, můžete jednoduše táhnout časovou osou myší.
                    </div>
                    <div className="positionIcon">
                        <div className="blockIcon">
                            <GiClick className="icon"/>
                        </div>
                    </div>
                </HelpTimeLine>
                <div className="layout">
                    <TimeLinePosition >
                        <TimeYear year="1999" down="true" info="Začali jsme působit jako „společnost s ručením omezeným“."/>
                        <TimeYear year="2002" up="true" info="Začali jsme působit jako „společnost s ručením omezeným“. "/>
                        <TimeYear year="2005" down="true" info="Začali jsme působit jako „společnost s ručením omezeným“. "/>
                        <TimeYear year="2008" up="true" info="Začali jsme působit jako „společnost s ručením omezeným“. "/>
                        <TimeYear year="2013" down="true" info="Začali jsme působit jako „společnost s ručením omezeným“. "/>
                        <TimeYear year="2015" up="true" info="Začali jsme působit jako „společnost s ručením omezeným“. "/>
                        <TimeYear year="2020" down="true" info="Začali jsme působit jako „společnost s ručením omezeným“. "/>
                    </TimeLinePosition>
                </div>
            </TimeLine>
            <div className="layout">
                <div>
                    <Title className="h-1 title-padding-1-bottom">
                        Náš tým
                    </Title>
                    <BlockTeam>
                        <OurTeam>
                            <div className="boxTeam">
                                <div className="boxTeamLayout">
                                    <div className="flex ">
                                        <div className="Icon">
                                            <HiUserGroup/>
                                        </div>
                                        <div className="h-3">
                                            Jedna velká <span className="underline">skládačka</span>
                                        </div>
                                    </div>
                                    <IconsBlock>
                                        <div className="iconBlock">
                                            <BsFillFileEarmarkCodeFill/>
                                        </div>
                                        <div className="iconBlock">
                                            <BsServer/>
                                        </div>
                                        <div className="iconBlock">
                                            <RiCustomerService2Fill/>
                                        </div>
                                        <div className="iconBlock">
                                            <MdDesignServices/>
                                        </div>
                                        <div className="iconBlock">
                                            <BsFillPaletteFill/>
                                        </div>
                                        <div className="iconBlock">
                                            <AiFillPlayCircle/>
                                        </div>
                                    </IconsBlock>
                                </div>

                            </div>
                        </OurTeam>
                        <TeamInfo>
                            <div className="scroll" {...events1} ref={ref1}>
                                <div className="boxTeam">
                                    <div className="boxTeamLayout">
                                        <div className="flex">
                                            <div className="Icon">
                                                <FaComments/>
                                            </div>
                                            <Question className="f-inter">
                                                Co o nás říká šéf?
                                            </Question>
                                        </div>
                                        <Answer>
                                            „Jsou to skvělí lidi, kteří bezvadně ovládají svou oblast práce, tvoří snadno a intuitivně většinou bez nutnosti korekce či velkého vedení. Jsem za to moc rád.“
                                        </Answer>

                                    </div>
                                </div>
                                <div className="boxTeam">
                                    <div className="boxTeamLayout">
                                        <div className="flex">
                                            <div className="Icon">
                                                <IoIosBeer/>
                                            </div>
                                            <Question className="f-inter">
                                                Co nejradši děláme?
                                            </Question>
                                        </div>
                                        <Answer>
                                            „Rádi si zajdeme na pivko do hospody. Zahrajeme PubQuiz.“
                                        </Answer>

                                    </div>
                                </div>
                                <div className="boxTeam">
                                    <div className="boxTeamLayout">
                                        <div className="flex">
                                            <div className="Icon">
                                                <IoIosBeer/>
                                            </div>
                                            <Question className="f-inter">
                                                Co nejradši děláme?
                                            </Question>
                                        </div>
                                        <Answer>
                                            „Rádi si zajdeme na pivko do hospody. Zahrajeme PubQuiz.“
                                        </Answer>

                                    </div>
                                </div>
                                <div className="boxTeam">
                                    <div className="boxTeamLayout">
                                        <div className="flex">
                                            <div className="Icon">
                                                <IoIosBeer/>
                                            </div>
                                            <Question className="f-inter">
                                                Co nejradši děláme?
                                            </Question>
                                        </div>
                                        <Answer>
                                            „Rádi si zajdeme na pivko do hospody. Zahrajeme PubQuiz.“
                                        </Answer>

                                    </div>
                                </div>
                            </div>
                        </TeamInfo>
                    </BlockTeam>
                </div>
            </div>
        </Block>
    );
}
const Block = styled.div`
  padding-top: 60px;
  background-color:var(--main-color);
  color:white;
`;
const TitleBlock = styled.div`
  font-size:64px;
  font-weight: bold;
  text-align: center;
  padding-bottom:10px;
`;
const Title = styled.div`
  padding-top:60px;
  text-align: center;
  font-size:42px;
  font-family:Inter;
  font-weight:bold;
  
`;
const Text = styled.div`
  font-size:17px;
  text-align: center;
`;
const TimeLine = styled.div`
  position:relative;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color:#B82A2F;
  height: 600px;
  @media (max-width: 768px) {
`;
const TimeLinePosition = styled.div`
  position:absolute;
  top: 50%;
  display:flex;
  .scroll-container{
    display:flex;
  }
`;
const HelpTimeLine = styled.div`
  position:relative;
  text-align: center;
  padding:10px 0 20px 0;
  .title{
    font-size:20px;
    font-weight: bold;
    padding: 20px 0 20px 0;
  }
  .positionIcon{
    display:flex;
    justify-content: center;
    .blockIcon{
      text-align: center;
      display:flex;
      justify-content: center;
      align-items: center;

      width: 60px;
      height: 60px;

      background-color:#F4D5D6;
      border-radius: 50%;
      .icon{
        color:var(--main-color);
        font-size:28px;
        padding-top:10px;
      } 
  }
  }
`;
const BlockTeam = styled.div`
  display:flex;
  .Icon{
    width: 50px;
    height: 50px;

    border-radius: 10px;
    
    display:flex;
    justify-content: center;
    align-items: center;

    font-size:28px;
    color:white;
    
    margin-right: 10px;
  }
  .flex{
    display:flex;
    align-items: center;
  }
  @media only screen and (max-width: 999px){
    display:block;
  }
`;
const OurTeam = styled.div`
  flex:1;
  .boxTeam{
    position:relative;
    width:95%;
    background-color:white;
    border-radius:20px;
    
    .boxTeamLayout{
      color:black;
      @media only screen and (max-width: 700px){
        padding:34px;
      }
      padding:40px; 
    }
    .Icon{
      background-color:var(--main-color);
      @media only screen and (max-width: 700px){
        width:50px;
        height:50px;
        margin-bottom:20px;
      }
    }
    .flex{
      padding-bottom:50px;
      @media only screen and (max-width: 700px){
        display:block;
      }
    }
  }
  @media only screen and (max-width: 999px){
    .boxTeam{
      width: 100%;
      margin-bottom:40px;
    }
  }
`;
const IconsBlock = styled.div`
  display:flex;
  justify-content: center;
  flex-wrap: wrap;
  @media only screen and (max-width: 700px){
    gap:20px;
  }
  gap:50px;
  
  margin-bottom:30px;
  .iconBlock{
    width: 100px;
    height: 100px;
    background-color:#F5F5F5;
    border-radius:20px;
    
    display:flex;
    justify-content: center;
    align-items: center;
    
    font-size:36px;
    @media only screen and (min-width: 500px) and (max-width: 700px){
      width:80px;
      height:80px;
    }
    @media only screen and (min-width: 450px) and (max-width: 499px){
      width: 140px;
      height: 120px;
    }
    @media only screen and (max-width: 450px){
      width: 80px;
      height: 80px;
    }
  }
`;
const TeamInfo = styled.div`
  flex:1;
  
  position: relative;
  .scroll{
    overflow-y: hidden;
    overflow-x: hidden;
    
    height: 460px;
  }
  .boxTeam{
    position:relative;
    width:95%;
    float:right;
    background-color:#F4D5D6;
    border-radius:20px;

    margin-bottom:10px;
    .boxTeamLayout{
      color:black;

      padding:40px;
      @media only screen and (max-width: 700px){
        padding:20px;
      }
    }
    .Icon{
      background-color:white;
      color:var(--main-color);
    }
    .flex{
      padding-bottom:25px;
    }
  }
  @media only screen and (max-width: 999px){
    .boxTeam{
      width: 100%;
    }
`;
const Question = styled.div`
  font-size:24px;
  font-weight: bold;
`;
const Answer = styled.div`
  font-style: italic;
  font-size:18px;
`;
export default AboutUs;